import React from 'react';

interface Props {
  overallClassName?: string;
}

const Loading: React.FC<Props> = ({ overallClassName }) => {
  return (
    <div className={overallClassName ? overallClassName : 'preloader'}>
      <div id="cooking">
        <div className="bubble"></div>
        <div className="bubble"></div>
        <div className="bubble"></div>
        <div className="bubble"></div>
        <div className="bubble"></div>
        <div id="area">
          <div id="sides">
            <div id="pan"></div>
            <div id="handle"></div>
          </div>
          <div id="pancake">
            <div id="pastry"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
